/* @flow */
import React from 'react';
import Transaction from 'entities/Transaction';
import { mountModal } from 'lib/modal';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Money from 'payments/components/Money.jsx';
import TransactionActions from 'payments/actions/TransactionActions';
import { showToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

type RefundConfirmDialogProps = {
  transaction: Transaction,
  onConfirm: Function,
};

function RefundConfirmDialog(props: RefundConfirmDialogProps) {
  const { transaction, onConfirm, ...rest } = props;

  const title = (
    <span>
      Are you sure you want to refund <Money cents={transaction.getAmount()} />
      to {transaction.getPayer().getDisplayName()}?
    </span>
  );

  return (
    <ConfirmDialog
      eventScreenName="Refund"
      {...rest}
      title={title}
      onConfirm={onConfirm}
      subtext="This operation cannot be undone"
    />
  );
}

type RefundProps = {
  children?: Function,
  transaction: Transaction,
  showToast: (text: string, kind: 'success' | 'error') => void,
};

type RefundState = {
  proccessing: boolean,
};

class Refund extends React.Component {
  props: RefundProps;
  state: RefundState = {
    proccessing: false,
  };

  onConfirm = () => {
    const activityId = this.props.transaction.getActivity().id;
    const transactionId = this.props.transaction.id;

    this.setState({ proccessing: true });

    TransactionActions
      .refund(activityId, transactionId)
      .then(
        () => this.props.showToast('Refund sent', 'success'),
        () => this.props.showToast('Oops, an unknow error happened.', 'error'),
      ).then(
        () => this.setState({ proccessing: false }),
      );
  }

  refund = () => {
    const modal = (
      <RefundConfirmDialog
        transaction={this.props.transaction}
        onConfirm={this.onConfirm}
      />
    );

    mountModal(modal, this);
  }

  noop = () => {}

  render = () => {
    return (this.props.children || this.noop)(this.refund, this.state.proccessing);
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ showToast }, dispatch);
}

export { Refund };
export default connect(undefined, mapDispatchToProps)(Refund);



// WEBPACK FOOTER //
// ./src/payments/components/Refund.jsx